module.exports = __webpack_public_path__ + "static/img/80.66bf6593.png";